<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M12 20c1.57 0 3.03-.46 4.26-1.24L14.8 17.3A6 6 0 0 1 6 12h3L5 8l-4 4h3a8 8 0 0 0 8 8Zm3-8 4 4 4-4h-3A8 8 0 0 0 7.74 5.24L9.2 6.7A6 6 0 0 1 18 12h-3Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
